// extracted by mini-css-extract-plugin
module.exports = {"root":"StageGrid_root__2jDxX"};